<template>
  <div class="container l:mt-2">
    <div
      class="flex rounded flex-col l:flex-row justify-between items-stretch l:items-center bg-background-blue/50 pb-6 pt-8 l:py-8 px-4 m:px-8"
    >
      <div class="flex-grow m:w-4/5 l:w-1/2 pr-6">
        <div class="flex items-center mb-4 l:mb-2 l:mt-4 text-blue">
          <check-icon />
          <p class="text-h5 l:text-h35 text-blue font-bold ml-2 mb-0 l:mb-0 uppercase">
            {{ heading || $t("heading") }}
          </p>
        </div>

        <p style="line-height: 22px" class="text-sm m:text-base text-dark-grey">
          {{ description || $t("description") }}
        </p>
      </div>

      <div class="flex-grow l:w-1/2 rounded bg-white p-4 m:py-4 m:px-6 l:px-12 l:ml-16">
        <p class="text-h6 font-bold mb-0 text-dark-grey">
          {{ $t("pricingTitle") }}
        </p>

        <p class="text-blue text-h2 font-bold mb-0">
          $0.00 <span class="text-base text-dark-grey">/{{ $t("month") }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CheckIcon from "@/component-library/icons/check-icon"

export default {
  name: "PricingCard",
  components: {
    CheckIcon
  },
  props: {
    heading: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  i18n: {
    messages: {
      en: {
        heading: "Already paid by your friend",
        description: "The subcription was paid from the account of the person that invited you.",
        pricingTitle: "You pay",
        month: "month"
      },
      de: {
        heading: "Kostenlos für dich",
        description: "Jeder Premium-Abonnent bekommt ein extra Konto zum Teilen – du wurdest eingeladen!",
        pricingTitle: "Du bezahlst",
        month: "Monat"
      }
    }
  }
}
</script>
